import React from "react";
import StaffProfileCard from "../../Staff/partials/StaffProfileCard";
import PatientCard from "../../Patient/partial/PatientCard";
import TimeAgo from "react-timeago";

const ListView = ({ items = [] }) => {
    if (items.length < 1)
        return (
            <div className="text-center text-pink">
                <i className="material-icons" style={{ fontSize: "4em" }}>
                    info
                </i>
                <br />
                <strong>No Appointment has been added yet</strong>
            </div>
        );
    return (
        <div className="no-pad table-responsive">
            <table className="table table-inbox table-hover table-bordered">
                <thead>
                    <tr className="text-left">
                        <th className="text-center">SN</th>
                        <th> Patient </th>
                        <th> Whom to See </th>
                        <th> Department</th>
                        <th> Date </th>
                        <th className="text-center">View note</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, index) => {
                        return (
                            <tr key={index}>
                                <td className="inbox-small-cells text-center">{index + 1}</td>
                                <td className="view-message">
                                    <PatientCard item={item.patient} />
                                </td>
                                <td>
                                    <StaffProfileCard item={item.assignee} />
                                </td>
                                <td className="view-message">
                                    {item.department.name}
                                    <br />
                                    {item.attended ? <span className="label label-sm label-success">Attended</span> : <span className="label label-sm label-danger">Unattended</span>}
                                </td>
                                <td className="view-message">
                                    <span>
                                        {Intl.DateTimeFormat("en-GB", {
                                            weekday: "short",
                                            month: "short",
                                            year: "numeric",
                                            day: "numeric",
                                        }).format(new Date(parseInt(item.date)))}
                                    </span>
                                    <br />
                                    <small>
                                        <TimeAgo date={new Date(parseInt(item.date))} />
                                    </small>
                                </td>
                                <td className="view-message text-center">
                                    <button onClick={() => alert(item.note)} className="mdl-button fade-in mdl-button--icon mdl-button--colored btn-default margin-right-10">
                                        <i className="material-icons text-primary">reorder</i>
                                    </button>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default ListView;
